<script type="text/javascript">
    
    import TabBar from '@smui/tab-bar';
	import Tab, { Label as TabLabel } from '@smui/tab';

    import Port from "./Port";
	import PortsStore from "./Store";
    import BaseModel from "../../Models/BaseModel";
    import LoadState from "../../Enums/LoadState";
    import PortPieChart from './PortPieChart.svelte';
    import PortLineChart from './PortLineChart.svelte';
    import User from '../../Branding/User';
    import Feature from '../../Branding/Feature';
    import PortHistogram from './PortHistogram.svelte';

    export let portData;

    let loadState = portData.port.loadState;
    let loadError = portData.port.loadError;

    let tabs = ["Info"];
    $: {
        if (portData) {
            if (User.hasFeature(Feature.MARITIME.PORTS.STATS.VIEW)) { 
                tabs = ["Info", "Stats"];
            }
            PortsStore.actions.loadPortStats(portData.port)
        }
    } 
    // ABERDEEN_GBABD
    // TIMACO_COTCO
    // HOGSET_NOHOG
    // JAMESTOWN_SHSHN
    // <NAME>_<CC>

</script>

<TabBar tabs={tabs} let:tab bind:active={portData.tab} class="border-shadow">
    <Tab tab={tab} minWidth><TabLabel>{tab}</TabLabel></Tab>
</TabBar>
<div class='p-10'>
    {#if portData.tab === "Info"}
        <div class="mdc-elevation--z2">
            <table class='svelte-table'>
                {#each Object.keys(Port._FieldKeys) as key}
                    <tr>
                        <td align="right">{key}</td>
                        <!-- <td align="left">{Port._FieldKeys[key].key}</td> -->
                        <td align="left">{Port._FieldKeys[key].transform(BaseModel.getMapResult(key, portData.port.data, Port._FieldKeysProps))}</td>
                    </tr>
                {/each}
            </table>
        </div>
    {:else if portData.tab === "Stats"}

        {#if $loadState === LoadState.INIT}
            {#if $loadError.length > 0}
                <p>Error: {$loadError}</p>    
            {/if}
        {:else if $loadState === LoadState.LOADING}
            <p>Loading...</p>
        {:else if $loadState === LoadState.LOADED}
            {#if portData.port.stats.length === 0}
                <p><b>No Chart Data available.</b></p>
            {:else}
                <PortLineChart title="Arrivals/Departures - last 30 days" days={30} data={portData.port.stats} keys={["Arrivals", "Departures"]}/><br/>
                <PortPieChart title="Flags - last 30 days" days={30} data={portData.port.stats} key={"Flag"} subkey={"country"} /><br/>
                <PortPieChart title="Vessel Types - last 30 days" days={30} data={portData.port.stats} key={"Ship_type"} subkey={"ship_type"} /><br/>
                <PortHistogram title="Total Time Spent in Port - last 30 days" data={portData.port.statsRolling} key={"time_hist"} avg={"average_time"} /><br/>
                <PortHistogram title="Draught change in Port - last 30 days" data={portData.port.statsRolling} key={"draught_hist"} xAxisDecimalPlaces={2} xAxisUnit={"Metres"} /><br/>
            {/if}    
        {/if}
    {/if}
</div>